import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import componentRenderedMixin from 'next/javascripts/mixins/component-rendered-mixin';
import request from 'next/javascripts/modules/request';
import currentMember from 'next/javascripts/modules/current-memebr';
import 'next/stylesheets/components/resource/collection';

Component('tr-resource-collection', {
  mixins: [eventListenerMixin, componentRenderedMixin],

  properties: {
    collected: {
      type: Boolean,
      default: false,
      observer() {
        this.setTooltip();
      },
    },

    tooltip: {
      type: Boolean,
      default: true,
    },

    url: String,
    resourceId: String,
    resourceType: String,
  },

  connected() {
    this.setTooltip();
    this.listenTo(this, 'click', this.handleClick.bind(this));

    if (this.rendered) return;
    this.getInfo();
  },

  async getInfo() {
    const member = await currentMember;
    this.getInfoXHR = request({
      url: `/members/${member.guid}/has_star`,
      type: 'GET',
      dataType: 'json',
      data: {
        starable_id: this.resourceId,
        starable_type: this.resourceType,
      },
      complete: () => {
        this.getInfoXHR = null;
      },
    }, ({ content }) => {
      this.collected = content.has_star;
    });
  },

  handleClick() {
    if (this.request) return;
    this.collected = !this.collected;
    this.request = $.ajax({
      url: this.url,
      type: 'POST',
      dataType: 'json',
    }).then(() => {
      this.request = null;
    });
  },

  setTooltip() {
    if (!this.tooltip) return;
    this.dataset.tooltip = this.collected ? '取消收藏' : '收藏';
    const tooltip = $(this).data('simple-tooltip');
    if (tooltip) tooltip.hide();
  },

  disconnected() {
    if (this.getInfoXHR) this.getInfoXHR.abort();
    this.stopListening();
  },
});
